export const courses = [
  {
    value: "",
    label: "",
  },
  {
    value: "Montacarga",
    label: "Montacarga",
  },
  {
    value: "Retroexcavadora",
    label: "Retroexcavadora",
  },
  {
    value: "Retro Oruga",
    label: "Retro Oruga",
  },
];
export const resolutions = [
  {
    value: "",
    label: "",
  },
  {
    value: "Resolucion 2888 de 2007 Decreto 4904 de 2009 MEN",
    label: "Resolucion 2888 de 2007 Decreto 4904 de 2009 MEN",
  },
  {
    value: "Resolucion 1409 de 2012 Decreto 4904 de 2009 MEN",
    label: "Resolucion 1409 de 2012 Decreto 4904 de 2009 MEN",
  },
];
